import { ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { PosComponent } from './pos.component';

export const PosGuardNavAway: CanDeactivateFn<PosComponent> = 
  (component: PosComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot) => {
    return component.checkNavGuard(nextState.url);
  };
